<template>
  <div class="md:p-[50px] lg:p-[100px]">
    <div
      v-for="(service, index) in mergeData"
      :key="index"
      class="rounded-[20px]"
    >
      <div class="w-full mx-auto my-10">
        <!-- <hr class="md:hidden lg:block" /> -->
        <div
          class="grid grid-cols-1 lg:grid-cols-2 items-center lg:w-full lg:h-[645px] gap-[10px]"
        >
          <!-- Image Section -->
          <div :class="['flex justify-center']">
            <div class="py-4 lg:p-[20px]">
              <img
                class="w-full lg:h-[565px] object-cover lg:rounded-[20px]"
                :src="service.image_path"
                alt=""
              />
            </div>
          </div>

          <!-- Content Section -->
          <div
            :class="['flex flex-col lg:w-[490px] lg:h-[565px] px-4 md:px-0 ']"
          >
            <!-- Content Wrapper -->
            <div class="flex flex-col w-full h-full gap-[50px] lg:gap-[0px]">
              <!-- Top Content -->
              <div class="flex flex-col gap-4">
                <h2 class="text-[24px] md:text-[36px] lg:text-[40px] font-bold">
                  {{ getLocalized(service, "name") }}
                </h2>
                <p
                  class="text-16px md:text-[20px] text-[#303030] font-light leading-relaxed"
                >
                  {{ getLocalized(service, "description") }}
                </p>

                <!-- Features List -->
                <div
                  v-if="service.sub_services && service.sub_services.length > 0"
                  class="flex flex-col gap-2 md:gap-[20px] md:mt-[20px]"
                >
                  <div
                    v-for="(feature, featureIndex) in service.sub_services"
                    :key="featureIndex"
                    class="flex gap-[10px] lg:gap-[20px] items-center"
                  >
                    <!-- Icon -->
                    <img
                      :src="checkMark"
                      class="w-[32px] h-[32px]"
                      alt="Feature Icon"
                    />
                    <!-- Name -->
                    <span
                      class="text-[12px] md:text-[16px] text-gray-700 align-middle"
                    >
                      {{ getLocalized(feature, "name") }}
                    </span>
                  </div>
                </div>

                <!-- Button - Correct placement of single button -->
                <div class="md:mt-2">
                  <a
                    v-if="service.url"
                    :href="service.url"
                    class="px-[12px] py-[6px] text-[14px] md:px-[24px] md:py-[12px] md:text-[16px] bg-tbt-blue text-white rounded-full hover:bg-tbt-blue/90 transition-colors"
                  >
                    {{ getLocalized1("title") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkMark from "@/assets/pictures/checkmark.svg";
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
export default {
  mounted() {
    this.fetchServiceData();
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
    getLocalized1() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },

  data() {
    return {
      servicesData: [],
      iconData: [],
      api: process.env.VUE_APP_API_KEY,
      mergeData: [],
      subMenu: [],
      checkMark: checkMark,
      translations: {
        title: {
          en: "View Details",
          kh: "មើលព័ត៌មានលម្អិត",
        },
      },

      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  methods: {
    async fetchServiceData() {
      try {
        const responseMain = await axios.get(this.api + "/api/main-services");
        this.servicesData = responseMain.data.items.map((item) => ({
          ...item,
          image_path: `${this.api}${item.image_path}`,
          sub_services: [],
          url: "",
        }));

        const response = await axios.get(
          this.api + "/api/sub-services/?page=1&page_size=20"
        );
        this.iconData = response.data.items;

        const responseSubMenu = await axios.get(this.api + "/api/submenus");
        this.subMenu = responseSubMenu.data.items
          .filter((item) => item.display_order >= 2 && item.display_order <= 6)
          .map((item) => ({
            url: `${item.url}`,
            name_en: `${item.name_en}`,
          }));

        // Merge sub-services and assign the correct submenu URL
        this.mergeData = this.servicesData.map((service) => {
          let subServices = [];
          if (service.id !== 1) {
            // Only fetch sub-services for services other than id === 1
            subServices = this.iconData
              .filter((icon) => icon.main_service_id === service.id)
              .map((sub) => ({
                ...sub,
                icon_path: sub.icon_path ? `${this.api}${sub.icon_path}` : null,
              }))
              .sort((a, b) => a.display_order - b.display_order);
          }

          // Find corresponding submenu URL for the service
          const subMenuUrl =
            this.subMenu.find((item) => item.name_en === service.name_en)
              ?.url || "";

          return {
            ...service,
            sub_services: subServices,
            url: subMenuUrl, // Merge the submenu URL into the service
          };
        });

        // Sort mergeData based on display_order of main services
        this.mergeData.sort((a, b) => a.display_order - b.display_order);
      } catch (error) {
        console.error("Error fetching or merging data:", error);
      }
    },
  },
};
</script>
